// extracted by mini-css-extract-plugin
module.exports = {"section":"NotFound_section__1f7CG","container":"NotFound_container__PScWX","error":"NotFound_error__2J4ea","title":"NotFound_title__1Oxqn","link":"NotFound_link__1mk8i"};